<div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50" *ngIf="isLoading | async">
  <div class="flex space-x-2">
    <div class="w-2 h-2 bg-white rounded-full animate-bounce delay-0"></div>
    <div class="w-2 h-2 bg-white rounded-full animate-bounce delay-200"></div>
    <div class="w-2 h-2 bg-white rounded-full animate-bounce delay-400"></div>
  </div>
</div>
